import React from 'react';
import PropTypes from "prop-types";
import { BlockButton, BlockButtonGroup } from '../ui/Block';
import { isDisabled } from '../../utils/controls';
import { TogglePrice } from './styled';
import RubleLightIcon from '../icons/RubleLightIcon';

const BlockComponent = (options) => {

    const {
        disabled,
        input,
        values,
        variation,
        label,
        imageGetFunction,
        excludedAttrs,
        displayName,
        hideTitle,
    } = options;

    const renderLabelPriceInjection = (price) => {
        return parseInt(price) > 0 ? 
            <TogglePrice marginTop={'2px'}>
                {price}&#160;
                <RubleLightIcon size={9} color='currentColor'/>
            </TogglePrice> : 
            null;
    }

    return (
        <div className='b-rit-block-group'>
            {!hideTitle && <p className='b-rit-form-group__title'>{displayName}</p>}
            <BlockButtonGroup
                {...input}
                onChange={(event, value) => {
                    input.onChange(value)
                }}
                onBlur={() => {
                    input.onBlur()
                }}
            >
                {values.sort((a, b) => {
                    return a.sortPosition > b.sortPosition
                }).map(({ attrValue, shortName, price }) => {
                    if (excludedAttrs && excludedAttrs.indexOf(attrValue) > -1) {
                        return false;
                    }
                    return (

                        <BlockButton
                            key={attrValue}
                            attrValue={attrValue}
                            lebelInjection={renderLabelPriceInjection(price)}
                            id={attrValue}
                            value={attrValue}
                            labelText={shortName}
                            labelTextInner={true}
                            variation={variation}
                            imageUrl={imageGetFunction(attrValue)}
                            disabled={isDisabled(disabled, attrValue)}
                        />

                    )
                })}
            </BlockButtonGroup>
        </div>
    )
}

BlockComponent.propTypes = {
    disabled: PropTypes.any.isRequired,
    input: PropTypes.object.isRequired,
    values: PropTypes.array.isRequired,
    variation: PropTypes.string.isRequired,
    label: PropTypes.string,
    imageGetFunction: PropTypes.func.isRequired,
    excludedAttrs: PropTypes.any,
    displayName: PropTypes.string,
    hideTitle: PropTypes.bool,
}

export default BlockComponent;